import { Router } from "./router";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "../styles/globals.css";

export function App() {
  return (
    <ErrorBoundary>
      <Router />
    </ErrorBoundary>
  );
}

export default App;
